import React from 'react';

interface WellProps {
  children?: React.ReactNode[];
}

export default class Well extends React.Component<WellProps, any> {
  static defaultProps = {
    children: null,
  }

  render() {
    return (
      <div className="well standard-well">
        <div className="wrapper">
          {this.props.children}
        </div>
      </div>
    );
  }
}
